import { useAuthContext } from "./useAuthContext";

export const useLogout = () => {
  const { dispatch } = useAuthContext();

  const logout = () => {
    //TODO: (low priority) Put user token into a blacklist so that it can't be used...
    //to hit the backend via postman, web browser (for GET requests) or similar app.
    //Also, this blacklist should be checked in requireAuth middleware of backend

    localStorage.removeItem("user");

    // dispatch logout action
    dispatch({ type: "LOGOUT" });
  };

  return { logout };
};
